interface ContractCountResponse {
  numContracts: number;
}

export const getNumContracts = async (strategyId: string = 'oyster'): Promise<number> => {
  const date = new Date();
  const currentMonth = date.getMonth() + 1; // JavaScript months are 0-indexed
  const nextMonth = currentMonth === 12 ? 1 : currentMonth + 1;
  const yearOfNextMonth =
    nextMonth === 1 ? date.getFullYear() + 1 : date.getFullYear();

  const urlCurrentMonth = `https://push.atomic.finance/strategy/${strategyId}/contract/count/${date.getFullYear()}/${currentMonth}`;
  const urlNextMonth = `https://push.atomic.finance/strategy/${strategyId}/contract/count/${yearOfNextMonth}/${nextMonth}`;

  const responseCurrentMonth = await fetch(urlCurrentMonth);
  const dataCurrentMonth: ContractCountResponse =
    await responseCurrentMonth.json();

  const responseNextMonth = await fetch(urlNextMonth);
  const dataNextMonth: ContractCountResponse = await responseNextMonth.json();

  return dataCurrentMonth.numContracts + dataNextMonth.numContracts;
};
